import React from 'react';
import { useTheme } from "@mui/material";
import { BsLinkedin, BsMastodon, BsThreads, BsTwitterX } from 'react-icons/bs';
import { AiFillFacebook, AiFillPinterest, AiFillTikTok, AiFillYoutube, AiOutlineInstagram } from 'react-icons/ai';
import { FaBluesky, FaReddit, FaRegNewspaper, FaSquareTumblr, FaWeibo } from 'react-icons/fa6';
import { SiVk } from 'react-icons/si';

export interface SocialIconProps {
  site: string;
  iconSize?: string;
}

export default function SocialIcon(props: SocialIconProps): React.JSX.Element {
  const theme = useTheme();

  const { site } = props;

  const iconSize = props.iconSize || "1.5rem";

  const siteToIcon = {
    "x.com": <BsTwitterX style={{ color: theme.colors.namedColors.x, fontSize: iconSize }} title="X" />,
    "twitter.com": <BsTwitterX style={{ color: theme.colors.namedColors.x, fontSize: iconSize }} title="X" />,
    "facebook.com": <AiFillFacebook style={{ color: theme.colors.namedColors.facebook, fontSize: iconSize }} title="Facebook" />,
    "youtube.com": <AiFillYoutube style={{ color: theme.colors.namedColors.youtube, fontSize: iconSize }} title="YouTube" />,
    "tiktok.com": <AiFillTikTok style={{ color: theme.colors.namedColors.tiktok, fontSize: iconSize }} title="TikTok" />,
    "instagram.com": <AiOutlineInstagram style={{ color: theme.colors.namedColors.instagram, fontSize: iconSize }} title="Instagram" />,
    "reddit.com": <FaReddit style={{ color: theme.colors.namedColors.reddit, fontSize: iconSize }} title="Reddit" />,
    "threads.net": <BsThreads style={{ color: theme.colors.namedColors.threads, fontSize: iconSize }} title="Threads" />,
    "threads.com": <BsThreads style={{ color: theme.colors.namedColors.threads, fontSize: iconSize }} title="Threads" />,
    "linkedin.com": <BsLinkedin style={{ color: theme.colors.namedColors.linkedin, fontSize: iconSize }} title="LinkedIn" />,
    "mastodon.social": <BsMastodon style={{ color: theme.colors.namedColors.twitter, fontSize: iconSize }} title="Mastodon" />,
    "vk.com": <SiVk style={{ color: theme.colors.namedColors.twitter, fontSize: iconSize }} title="VK" />,
    "pinterest.com": <AiFillPinterest style={{ color: theme.colors.namedColors.pinterest, fontSize: iconSize }} title="Pinterest" />,
    "weibo.com": <FaWeibo style={{ color: theme.colors.namedColors.reddit, fontSize: iconSize }} title="Weibo" />,
    "tumblr.com": <FaSquareTumblr style={{ color: theme.colors.namedColors.twitter, fontSize: iconSize }} title="Tumblr" />,
    "bsky.app": <FaBluesky style={{ color: theme.colors.namedColors.bluesky, fontSize: iconSize }} title="Bluesky" />,
    "truthsocial.com": <FaRegNewspaper style={{ color: "rgb(84, 72, 238)", fontSize: iconSize }} title="Truth Social" />, // No official icon supported
  }

  const innerSite = site?.toLowerCase()?.trim() || null;
  const icon = site ? siteToIcon[innerSite] : null;

  return (
    <>
      {icon}
      {!icon && (
        <FaRegNewspaper style={{ color: theme.colors.namedColors.lexisnexis, fontSize: iconSize }} />
      )}
    </>
  );
}